export default __webpack_public_path__ + "static/media/abstract.c4a24716.jpg";